




























































import { Vue, Component } from 'vue-property-decorator';
import DataTable from '../components/DataTable.vue';
import { ObjectFactory } from '../config/objectFactory';
import { RequestStatus, ServiceRequest } from '../types/entity';
import { DateUtils } from '../util/dateUtils';
import ViewRequestDetailModal from './modal/ViewRequestDetailModal.vue';
// import { Condition } from '../types/queryRequest';
import AdvanceSearchFilterModal from '../views/modal/AdvanceSearchFilterModal.vue';
import { AdvanceFilterRequest } from '@/types/request';

// tslint:disable-next-line: no-var-requires
const TransportationRequestsTable = require('../datatable/AllTransportRequestsTable.json');
// tslint:disable-next-line: no-var-requires
const InterpretationRequestsTable = require('../datatable/AllInterpreterRequestsTable.json');
// tslint:disable-next-line: no-var-requires
const DeliveryRequestTable = require('../datatable/AllDeliveryRequestTable.json');
// tslint:disable-next-line: no-var-requires
const HomeAssistanceRequestsTable = require('../datatable/AllHomeAssistanceRequestsTable.json');
// tslint:disable-next-line: no-var-requires
const HomeHealthCareRequestsTable = require('../datatable/AllHomeHealthCareRequestsTable.json');
// tslint:disable-next-line: no-var-requires
const CmrRequestsTable = require('../datatable/AllCmrRequestsTable.json');
@Component({
    watch: {
        $route(to, from) {
            const request = this as Requests;
            request.getServiceRequests();
        },
    },
    components: {
        DataTable,
        ViewRequestDetailModal,
        AdvanceSearchFilterModal,
    },
})
export default class Requests extends Vue {
    private requestType: any = '';
    private transportationDatasource = TransportationRequestsTable;
    private interpretationDatasource = InterpretationRequestsTable;
    private deliveryDatasource = DeliveryRequestTable;
    private homeAssistanceDatasource = HomeAssistanceRequestsTable;
    private homeHealthCareDatasource = HomeHealthCareRequestsTable;
    private cmrDatasource = CmrRequestsTable;
    private status: any = '';
    private sessionInfo = ObjectFactory.getCacheService().getSessionInfo();
    private showAdvancedFilter = false;
    private advanceFilterRequest: AdvanceFilterRequest = {};
    private isCNA = false;

    public async mounted() {
        this.resetFilter();
        this.getServiceRequests('', 0);
    }
    private openAdvancedFilter() {
        this.showAdvancedFilter = true;
    }

    private async getServiceRequests(searchString?: string, start?: number) {
        this.advanceFilterRequest.searchString = searchString;
        const requestType = this.$route.query.requestType;
        if (this.sessionInfo.scopes.includes('transporter') || this.sessionInfo.scopes.includes('driver')
            || this.sessionInfo.scopes.includes('dispatcher')) {
            this.requestType = requestType ? requestType : 'transportRequest';
            const partnerService = ObjectFactory.getPartnerService();
            const partner = await partnerService.getPartnerProfile(this.$store.state.serverUrl);
            if (partner.data && partner.data.transporterProfile) {
                const transporter = partner.data.transporterProfile;
                if (transporter.roles && transporter.roles.includes('CNA')) {
                    this.isCNA = true;
                    this.requestType = 'homeAssistanceRequest' || 'homeHealthCareRequest';
                }
            }
        } else if (this.sessionInfo.scopes.includes('homeHealthCare')) {
            this.requestType = requestType ? requestType : 'homeHealthCareRequest';
        } else {
            this.requestType = requestType ? requestType : 'interpreterRequest';
        }
        if (!start) {
            start = 0;
        }
        const status = this.$route.query.status;
        if (status) {
            this.advanceFilterRequest.status = [status as RequestStatus];
        }
        const response = await ObjectFactory.getRequestService().getRequests({
            advanceSearchRequest: this.advanceFilterRequest,
            baseURL: this.$store.state.serverUrl,
            service: this.requestType,
            start,
        });
        if (response.success && response.data) {
            switch (this.requestType) {
                case 'transportRequest':
                    this.getFormattedTransportationRequests(response.data);
                    if (response.totalCount !== undefined) {
                        this.transportationDatasource.totalCount = response.totalCount;
                    }
                    break;
                case 'homeAssistanceRequest':
                    this.getFormattedHomeAssistanceRequests(response.data);
                    if (response.totalCount !== undefined) {
                        this.homeAssistanceDatasource.totalCount = response.totalCount;
                    }
                    break;
                case 'homeHealthCareRequest':
                    this.getFormattedHomeHealthCareRequests(response.data);
                    if (response.totalCount !== undefined) {
                        this.homeHealthCareDatasource.totalCount = response.totalCount;
                    }
                    break;

                case 'interpreterRequest':
                    this.getFormattedInterpretationRequests(response.data);
                    if (response.totalCount !== undefined) {
                        this.interpretationDatasource.totalCount = response.totalCount;
                    }
                    break;

                case 'deliveryRequest':
                    this.getFormattedDeliveryRequests(response.data);
                    if (response.totalCount !== undefined) {
                        this.deliveryDatasource.totalCount = response.totalCount;
                    }
                    break;
                case 'cmrRequest':
                    this.getFormattedCmrRequests(response.data);
                    if (response.totalCount) {
                        this.cmrDatasource.totalCount = response.totalCount;
                    }
                    break;
            }
        } else {
            this.transportationDatasource.data = [];
            this.interpretationDatasource.data = [];
            this.deliveryDatasource.data = [];
            this.cmrDatasource.data = [];
            this.homeHealthCareDatasource.data = [];
        }
    }

    private getFormattedTransportationRequests(result: ServiceRequest[]) {
        result.forEach((element: any) => {
            element.appointment.timestamp =
                DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM,
                    element.appointment.timezone);
        });
        this.transportationDatasource.data = result;
    }

    private getFormattedCmrRequests(result: ServiceRequest[]) {
        result.forEach((element: ServiceRequest) => {
            element.appointment.date = DateUtils.formatDate(element.appointment.date,
                DateUtils.FORMAT_DATETIME_AM_PM) as any;
            element.createdOn = DateUtils.formatDate(element.createdOn, DateUtils.FORMAT_DATETIME_AM_PM,
                element.appointment.timezone) as any;
            element.appointment.timestamp =
                DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM,
                    element.appointment.timezone) as any;
        });
        this.cmrDatasource.data = result;
    }

    private getFormattedHomeAssistanceRequests(result: ServiceRequest[]) {
        result.forEach((element: any) => {
            const appointmentTimestamp =
                DateUtils.convertToUTCInMillis(element.homeAssistanceRequest.appointmentDate + ' ' +
                    element.homeAssistanceRequest.appointmentTime, element.appointment.timezone);
            const appointmentTime = DateUtils.formatDate(appointmentTimestamp,
                DateUtils.FORMAT_DATETIME_AM_PM, element.appointment.timezone);
            element.homeAssistanceRequest.appointmentDate = appointmentTime;
            element.appointment.timestamp =
                DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM,
                    element.appointment.timezone);
            element.createdOn = DateUtils.formatDate(element.createdOn, DateUtils.FORMAT_DATETIME_AM_PM,
                element.appointment.timezone);
        });
        this.homeAssistanceDatasource.data = result;
    }

    private getFormattedHomeHealthCareRequests(result: ServiceRequest[]) {
        result.forEach((element: any) => {
            element.appointment.timestamp =
                DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM,
                    element.appointment.timezone);
        });
        this.homeHealthCareDatasource.data = result;
    }

    private getFormattedInterpretationRequests(result: ServiceRequest[]) {
        result.forEach((element: any) => {
            element.appointment.timestamp =
                DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM,
                    element.appointment.timezone);
        });
        this.interpretationDatasource.data = result;
    }

    private getFormattedDeliveryRequests(result: ServiceRequest[]) {
        result.forEach((element: any) => {
            element.appointment.timestamp =
                DateUtils.formatDate(element.appointment.timestamp, DateUtils.FORMAT_DATETIME_AM_PM,
                    element.appointment.timezone);
            element.deliveryRequest.deliveryItems.forEach((item: string) => {
                if (element.deliveryItems) {
                    element.deliveryItems = `${element.deliveryItems}, ${item}`;
                } else {
                    element.deliveryItems = `${item}`;
                }
            });
        });
        this.deliveryDatasource.data = result;
    }

    private showViewRequestModal(serviceRequest: any) {
        this.$router.push({ path: `/service-requests/${serviceRequest.id}` });
    }

    private async filterRequests(filter: any) {
        this.getServiceRequests('', 0);
    }

    private resetFilter() {
        this.advanceFilterRequest = {
            appointmentDate: {},
        };
    }

}
